import { getGpuTemperatures } from '@/features/monitoring/api/prometheusApi';

import { createGpuMetricHook } from './createGpuMetricHook';

/**
 * GPU 온도 조회 Hook
 */
export const useGpuTemperatures = createGpuMetricHook('gpu-temperatures', getGpuTemperatures);
